import { render, staticRenderFns } from "./GroupParentSelect.vue?vue&type=template&id=1ccbde30"
import script from "./GroupParentSelect.vue?vue&type=script&lang=js"
export * from "./GroupParentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports